<footer class="govbook-footer">
  <div class="govbook-footer__pre-footer">
    <div class="govbook-container">
      <div class="row">
        <div class="col-sm-12 col-md-8 d-md-flex text-center text-md-start align-items-end">
          <img src="gloucester_logo_footer.png" alt="RBWM footer" class="logo">
          <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.gloucestershire.gov.uk/births-marriages-deaths-and-civil-partnerships/">Registration
                services pages on Gloucestershire County Council Website</a>

            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://gloucestershireregistrationservice.co.uk/terms-and-conditions/">Terms & Conditions</a>

            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.gloucestershire.gov.uk/council-and-democracy/data-protection/service-specific-privacy-notices/community-services-and-safety-privacy-notice/">Privacy
                Notice</a>
            </li>
            <li class="menu-item">
              <a target="_blank" aria-label="Accessibility statement (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility statement</a>
            </li>
          </ul>
        </div>

        <div class="col-sm-12 col-md-4">
          <div class="govbook-region govbook-region--footer-first region region-footer-first">
            <div class="govbook-container padding-horizontal">
              <div class="govbook-region__inner govbook-region__inner--footer-first">

              </div>
            </div>
          </div>

          <div class="govbook-region govbook-region--footer-third region region-footer-third">
            <div class="govbook-container padding-horizontal">
              <div class="govbook-region__inner govbook-region__inner--footer-third text-center text-md-start">
                <h4>Email us</h4>
                <a href="mailto:ceremony@gloucestershire.gov.uk" class="footer-links">ceremony&#64;gloucestershire.gov.uk</a>
                <nav aria-labelledby="block-ecc-theme-gov-socialmedia-menu" id="block-ecc-theme-gov-socialmedia"
                  class="block block-menu navigation navigation--social-media">
                  <h2 class="visually-hidden" id="block-ecc-theme-gov-socialmedia-menu">
                    Social Media
                  </h2>

                  <ul class="menu menu--social-media justify-content-end justify-content-md-start mt-3">
                    <li class="menu-item">
                      <a target="_blank" aria-label="Facebook (opens in new window)" class="footer-links"
                        href="https://www.facebook.com/GlosGRS/" class="social-link facebook">Facebook</a>
                    </li>
                    <li class="menu-item">
                      <a target="_blank" aria-label="Youtube (opens in new window)" class="footer-links"
                        href="https://www.youtube.com/@GlosRegistrationService" class="social-link youtube">YouTube</a>
                    </li>
                    <li class="menu-item">
                      <a target="_blank" aria-label="Instagram (opens in new window)" class="footer-links"
                        href="https://www.instagram.com/gloucestershire_registration/" class="social-link instagram">YouTube</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="govbook-footer__footer">
    <div class="govbook-container">
      <div class="govbook-row">
        <div class="govbook-row__full">
          <div class="govbook-region govbook-region--footer region region-footer">
            <div class="padding-horizontal">
              <div class="govbook-region__inner govbook-region__inner--footer">
                <div id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
                  class="block block-localgov-core block-localgov-powered-by-block">
                  <span>Powered by
                    <a target="_blank" aria-label="Bookinglab | GovBook (opens in new window)" class="footer-links"
                      href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=ecc
                                            ">bookinglab | GovBook</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>